import { Injectable, signal, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { LanguageType } from '../types';
import { LOCAL_STORAGE } from '@core-utils';

@Injectable()
export class SwitchLanguageService {
  private translocoService = inject(TranslocoService);

  private static SELECTED_LANGUAGE = LOCAL_STORAGE.SELECTED_LANGUAGE;
  currentLang = signal<LanguageType>(
    SwitchLanguageService.retrieveStoredLanguage() as LanguageType,
  );

  constructor() {
    this.translocoService.setActiveLang(this.currentLang());
  }

  setTranslation(lang: LanguageType) {
    this.translocoService.setActiveLang(lang);
    this.currentLang.set(lang);
    localStorage.setItem(SwitchLanguageService.SELECTED_LANGUAGE, lang);
  }

  static getStoredLanguage(): string {
    return SwitchLanguageService.retrieveStoredLanguage();
  }

  private static retrieveStoredLanguage(): string {
    const storedLang = localStorage.getItem(
      SwitchLanguageService.SELECTED_LANGUAGE,
    );
    return storedLang || 'en';
  }
}
